export default __webpack_public_path__ + "static/media/Punto_04_Quartiere_Venezia_ITA_Def.e6c6bae3.aac";